export default __webpack_public_path__ + "static/media/AOE2.0b15f9a9.jpg";